import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const switchLocaleRoutine = createRoutine('Intl/SWITCH_LOCALE')
export const createSwitchLocalePromise = promisifyRoutine(switchLocaleRoutine)
